import { Grid } from "@mui/material";
import AlertComponent from "../../../../components/AlertMessage/AlertMessage"
import UploadErrorDataList from "./UploadErrorDataList"

const UploadErrorInfoAlert = ({
    translate,
    presentationUploadErrors,
    establishmentsOptions = [],
    contractsOptions,
    testID = 'errorsInfo'
}: any) => {
    if (!presentationUploadErrors || Object.keys(presentationUploadErrors).length === 0)
        return null;

    return (
        <Grid display="flex" direction={'row'} bgcolor={'#fff'} pb={2} pl={3.5} pr={3.5}>
            <AlertComponent
                data-testID={testID}
                severity="info"
                message={translate('header.errorsInfo.message')}
                sx={{
                    textAlign: 'left',
                    fontSize: '16px'
                }}
                content={
                    <>
                        {presentationUploadErrors && (
                            <UploadErrorDataList
                                data={presentationUploadErrors}
                                establishments={establishmentsOptions}
                                contracts={contractsOptions || []}
                                translate={translate}
                            />
                        )}
                    </>
                }
            />
        </Grid>
    );
};

export {UploadErrorInfoAlert}